module.exports = "<ui-select ng-model=\"$ctrl.model\" name=\"bill-country\" autocomplete=\"billing country\" required form-field-errors>\n    <ui-select-match placeholder=\"Country\">\n        {{ $select.selected.name }}\n    </ui-select-match>\n    <ui-select-choices repeat=\"item.key as item in $ctrl.countries | filter: $select.search track by item.key\">\n        <span ng-bind=\"item.name\"></span>\n    </ui-select-choices>\n</ui-select>";


//////////////////
// WEBPACK FOOTER
// ./frontend/admin/app/modules/shared/journey-ui/payment/views/country.selector.html
// module id = 344
// module chunks = 0